

const Accessories = () => {
  return (
    <div>Accessories</div>
  )
}

export default Accessories